import React, { useState } from "react";
import NumberFormat from "react-number-format";

import CloseIcon from "@mui/icons-material/Close";
import { Button, CircularProgress, IconButton, Stack, TextField, Typography } from "@mui/material";
import { useActionHook } from "hooks";
import { useReportsQueriesSelector } from "store";
import { ReportPredictionTableCell } from "store/types";

import { currencySign } from "../../../../constants";

interface Props {
  cellData?: ReportPredictionTableCell;
  onCancel: () => void;
  onSubmit: (data: { value: string; isReset?: boolean }) => Promise<void>;
}

export const SettingCell: React.FC<Props> = ({ cellData, onCancel, onSubmit }) => {
  const { user_id, value } = cellData || {};
  const [localValue, setLocalValue] = useState<string>(value || "");
  const { currency } = useReportsQueriesSelector();

  const currencySymbol = currencySign[currency] || "";

  const { action: handleSubmit, loading } = useActionHook(onSubmit);

  return (
    <Stack sx={{ gap: "20px", p: "24px", boxShadow: "sm", borderRadius: "8px" }}>
      <Stack sx={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
        <Typography sx={{ fontSize: "18px", fontWeight: 400, color: "#071F35", lineHeight: "24px" }}>
          Change value
        </Typography>
        <IconButton onClick={onCancel}>
          <CloseIcon />
        </IconButton>
      </Stack>
      <NumberFormat
        customInput={TextField}
        value={localValue}
        onValueChange={({ value }) => setLocalValue(value)}
        thousandSeparator
        prefix={currencySymbol}
        allowNegative={false}
        decimalScale={2}
        fullWidth
        autoFocus
      />
      <Stack sx={{ flexDirection: "row", justifyContent: "flex-end", gap: "10px" }}>
        {user_id && (
          <Button variant="outlined" onClick={() => handleSubmit({ value: localValue, isReset: true })}>
            Reset
          </Button>
        )}
        <Button variant="outlined" onClick={onCancel} disabled={loading}>
          Cancel
        </Button>
        {loading ? (
          <Stack sx={{ width: 60, alignItems: "center" }}>
            <CircularProgress size={24} />
          </Stack>
        ) : (
          <Button variant="contained" onClick={() => handleSubmit({ value: localValue })}>
            Apply
          </Button>
        )}
      </Stack>
    </Stack>
  );
};
